import { Inject } from '@odinjs/odin';

import { DeckAPI, FormAPI, PanelAPI } from '@philips-emr/tws-components';
import Controller, { OnAfterFetch, OnChange, OnSelectItem } from '@philips-emr/tws-core/lib/client';
import { ChangeEvent, FetchEvent, SelectItemEvent } from '@philips-emr/tws-core/lib/component/types';

import { NegotiationValueSidebarMenuAliases as Aliases, FragmentNames } from '../../codegen';

enum MenuTypes {
  PROPOSAL    = '1',
  PROCEDURES  = '2',
  SERVICES    = '3',
  MATERIALS   = '4',
  PACKAGES    = '5',
}

@Controller({ fragment: FragmentNames.NEGOTIATION_VALUE_SIDEBAR_MENU })
class NegotiationValueSidebarMenuController {

  @Inject(Aliases.PANEL_PROPOSAL)
  private panelProposal: PanelAPI;
  @Inject(Aliases.PANEL_PROCEDURES)
  private panelProcedures: PanelAPI;
  @Inject(Aliases.PANEL_MATERIALS)
  private panelMaterials: PanelAPI;
  @Inject(Aliases.PANEL_SERVICES)
  private panelServices: PanelAPI;
  @Inject(Aliases.DECK_MENU)
  private deckMenu: DeckAPI;
  @Inject(Aliases.FORM_MENU_MOBILE)
  private formMenuMobile: FormAPI;
  @Inject(Aliases.PANEL_PACKAGES)
  private panelPackages: PanelAPI;

  @OnAfterFetch(Aliases.FETCH_MENUS)
  onAfterFetch(): void {
    this.deckMenu.selectCard(MenuTypes.PROPOSAL);
  }

  @OnSelectItem(Aliases.DECK_MENU)
  onselect(event: SelectItemEvent<any>): void {
    const { id } = event.item;
    this.visibilityControl(id);
  }

  @OnChange(Aliases.AUTOCOMPLETE_MENU_MOBILE)
  onchangeAutoComplete(event: ChangeEvent<{ id: MenuTypes }>): void {
    this.visibilityControl(event.value.id);
  }

  private visibilityControl(menu: string): void {
    this.panelProposal.setVisible(menu == MenuTypes.PROPOSAL);
    this.panelProcedures.setVisible(menu == MenuTypes.PROCEDURES);
    this.panelMaterials.setVisible(menu == MenuTypes.MATERIALS);
    this.panelPackages.setVisible(menu == MenuTypes.PACKAGES);
    this.panelServices.setVisible(menu == MenuTypes.SERVICES);
  }

  @OnAfterFetch(Aliases.FETCH_MENUS_MOBILE)
  onAfterFetchMenuMobile(event: FetchEvent): void {
    const data = event.data as [{ pendencies: [], hideImage: boolean }];
    if (data) {
      const record = [...data].shift();
      record && this.formMenuMobile.setRecord({ menuMobile: record });
    }
  }

}

export default NegotiationValueSidebarMenuController;
